<nz-empty *ngIf="!fields || !fields.length"></nz-empty>

<div
    nz-row
    class="fields-list"
    style="width: 100%; max-width: 780px"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
>
    <div
        *ngFor="let field of fields; index as i"
        nz-col
        nzXs="24"
        nzMd="24"
        cdkDrag="edit"
        [cdkDragDisabled]="!edit"
        (cdkDragStarted)="startDraging()"
        (cdkDragEnded)="endDraging()"
    >
        <!-- hide add for group fields -->
        <ng-container *ngIf="!field.group">
            <div
                *ngIf="edit && !dragging && !field.group"
                class="add-field-wrapper"
            >
                <button
                    nz-popover
                    [nzPopoverTitle]="addFieldPopoverTitleTemplate"
                    [nzPopoverContent]="addFieldPopoverContentTemplate"
                    [nzPopoverTrigger]="'focus'"
                    (focus)="addFieldIndex = i"
                >
                    <i nz-icon nzType="plus-circle" nzTheme="fill"></i>
                </button>
            </div>
        </ng-container>

        <div
            class="field-wrapper"
            [ngClass]="{
                section: field.type === 'section',
                active:
                    activeField?.index === i && activeField?.mode === 'edit',
                group: field.type === 'group',
                'group-field': field.group,
                dragable: edit
            }"
            [ngStyle]="{ 'margin-top': edit && !dragging ? '0px' : '10px' }"
        >
            <div class="field-title">
                {{ field.label | titlecase }}
                <!-- schema name -->
                <nz-tag *ngIf="field.schema" [nzColor]="'cyan'"
                    >{{ field.schema.schemaName | schemaTitle }}
                </nz-tag>
            </div>
            <div class="field-info">
                <div class="field-type">
                    <i
                        nz-icon
                        [nzType]="filedTypes[field.type]?.icon"
                        nzTheme="outline"
                    ></i
                    >{{ field.type }}
                </div>
            </div>
            <div class="field-actions">
                <button
                    *ngIf="edit"
                    nz-button
                    nzType="text"
                    (click)="openFieldDetails(field, i)"
                >
                    <i nz-icon nzType="edit" nzTheme="outline"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- add new field main -->
<div *ngIf="edit" class="add-field-main-wrapper">
    <button
        nz-button
        nzSize="large"
        nzType="primary"
        nzShape="round"
        nz-popover
        [nzPopoverTitle]="addFieldPopoverTitleTemplate"
        [nzPopoverContent]="addFieldPopoverContentTemplate"
        [nzPopoverTrigger]="'focus'"
        (focus)="addFieldIndex = null"
    >
        <i class="fa-solid fa-plus"></i>
        Add a field
    </button>
</div>

<!-- ----------------------------------------------------------------------- -->
<!--                                 Drawer                                  -->
<!-- ----------------------------------------------------------------------- -->
<nz-drawer
    [nzClosable]="false"
    [nzVisible]="!!activeField"
    nzPlacement="right"
    nzWidth="450px"
    nzTitle="Field Details"
>
    <ng-container *nzDrawerContent>
        <form
            nz-form
            [formGroup]="activeFieldFG"
            nzLayout="vertical"
            *ngIf="activeField"
        >
            <!-- name -->
            <nz-form-item>
                <nz-form-label nzRequired>Name </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <input
                        nz-input
                        placeholder="Field Name (not editable)"
                        formControlName="name"
                    />
                </nz-form-control>
            </nz-form-item>
            <!-- label -->
            <nz-form-item>
                <nz-form-label nzRequired>Label </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <input
                        formControlName="label"
                        nz-input
                        placeholder="Field Label"
                    />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item
                style="margin-top: -24px"
                *ngIf="
                    fieldType === 'text' ||
                    fieldType === 'email' ||
                    fieldType === 'number' ||
                    fieldType === 'phone' ||
                    fieldType === 'date' ||
                    fieldType === 'area' ||
                    fieldType === 'singleselect' ||
                    fieldType === 'multiselect'
                "
            >
                <nz-form-control>
                    <label nz-checkbox formControlName="standaloneLabel"
                        >Standalone Label</label
                    >
                    <i
                        nz-icon
                        nzType="info-circle"
                        nzTheme="outline"
                        nz-tooltip
                        nzTooltipTitle="By default the label will appear as a placeholder, check this option to make the label show as standalone and you can set another text as a placeholder for this field"
                    ></i>
                </nz-form-control>
            </nz-form-item>
            <!-- placeholder (if standalone label) -->
            <nz-form-item
                *ngIf="
                    activeFieldFG.get('standaloneLabel').value &&
                    (fieldType === 'text' ||
                        fieldType === 'email' ||
                        fieldType === 'number' ||
                        fieldType === 'area' ||
                        fieldType === 'singleselect' ||
                        fieldType === 'multiselect')
                "
            >
                <nz-form-label>Placeholder </nz-form-label>
                <nz-form-control>
                    <input
                        formControlName="placeholder"
                        nz-input
                        placeholder="Field Placeholder"
                    />
                </nz-form-control>
            </nz-form-item>

            <!-- width -->
            <nz-form-item
                *ngIf="
                    fieldType === 'text' ||
                    fieldType === 'email' ||
                    fieldType === 'number' ||
                    fieldType === 'phone' ||
                    fieldType === 'date' ||
                    fieldType === 'singleselect' ||
                    fieldType === 'multiselect'
                "
            >
                <nz-form-label nzRequired>Width </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <nz-slider
                        [nzMarks]="marks"
                        nzDots
                        formControlName="width"
                    ></nz-slider>
                </nz-form-control>
            </nz-form-item>

            <!-- Group Options -->
            <ng-container *ngIf="fieldType == 'group'">
                <nz-form-label>Repeat Type </nz-form-label>
                <nz-form-item>
                    <nz-form-control nzErrorTip="Required">
                        <nz-select
                            style="width: 100%"
                            nzAllowClear
                            formControlName="repeatType"
                        >
                            <nz-option
                                [nzValue]="'user'"
                                [nzLabel]="'Dynamic'"
                            ></nz-option>
                            <nz-option
                                [nzValue]="'constant'"
                                [nzLabel]="'Constant'"
                            ></nz-option>
                            <nz-option
                                [nzValue]="'field'"
                                [nzLabel]="'Number Field (user input)'"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <ng-container
                    *ngIf="activeFieldFG.get('repeatType').value == 'constant'"
                >
                    <nz-form-item>
                        <nz-form-label>Repeat Count </nz-form-label>
                        <nz-form-control nzErrorTip="Required">
                            <nz-input-number
                                formControlName="repeatConstant"
                                [nzMin]="1"
                                [nzStep]="1"
                            ></nz-input-number>
                        </nz-form-control>
                    </nz-form-item>
                </ng-container>

                <ng-container
                    *ngIf="activeFieldFG.get('repeatType').value == 'field'"
                >
                    <ng-container
                        *ngIf="
                            activeField.field
                                | otherFieldsByType
                                    : fields
                                    : 'number' as numberFields
                        "
                    >
                        <ng-container
                            *ngIf="
                                numberFields.length;
                                else noAvailableNumberFieldsTpl
                            "
                        >
                            <nz-form-item>
                                <nz-form-label>Field Name </nz-form-label>
                                <nz-form-control nzErrorTip="Required">
                                    <nz-select
                                        formControlName="repeatFieldName"
                                        style="width: 100%"
                                        nzAllowClear
                                    >
                                        <nz-option
                                            *ngFor="
                                                let numberField of numberFields
                                            "
                                            [nzValue]="numberField.name"
                                            [nzLabel]="numberField.name"
                                        >
                                        </nz-option>
                                    </nz-select>
                                </nz-form-control>
                            </nz-form-item>
                        </ng-container>
                        <ng-template #noAvailableNumberFieldsTpl>
                            <nz-alert
                                nzType="warning"
                                nzMessage="No number fields in this form"
                            ></nz-alert>
                        </ng-template>
                    </ng-container>
                </ng-container>
            </ng-container>

            <!-- credit card public key -->
            <nz-form-item *ngIf="fieldType == 'creditcard'">
                <nz-form-label>Public Key </nz-form-label>
                <nz-form-control>
                    <input
                        formControlName="publicKey"
                        nz-input
                        placeholder="Public Stripe Key"
                    />
                </nz-form-control>
            </nz-form-item>

            <!-- type -->
            <nz-form-item *ngIf="fieldType !== 'group'">
                <nz-form-label nzRequired>Type </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <nz-select formControlName="type" style="width: 100%">
                        <nz-option
                            *ngFor="let type of filedTypesArr"
                            [nzValue]="type.type"
                            [nzLabel]="type.label"
                            [nzDisabled]="type.disabled"
                        >
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <!-- options, for select and multiselect -->
            <nz-form-item
                *ngIf="
                    fieldType == 'singleselect' || fieldType == 'multiselect'
                "
            >
                <nz-form-label nzRequired>Options </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <nz-select
                        formControlName="options"
                        style="width: 100%"
                        nzMode="tags"
                    >
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <!-- variant -->
            <nz-form-item *ngIf="filedTypes[fieldType]?.variants as variants">
                <nz-form-label>Variant </nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="variant" style="width: 100%">
                        <nz-option [nzValue]="null" nzLabel="default">
                        </nz-option>
                        <nz-option
                            *ngFor="let variant of variants"
                            [nzValue]="variant"
                            [nzLabel]="variant"
                        >
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <!-- Is required -->
            <nz-form-item
                *ngIf="fieldType !== 'section' && fieldType !== 'group'"
            >
                <nz-form-control>
                    <label
                        style="margin-top: 10px"
                        nz-checkbox
                        formControlName="required"
                        >Is Required</label
                    >
                </nz-form-control>
            </nz-form-item>
            <!-- Is Hidden -->
            <nz-form-item
                *ngIf="fieldType !== 'section' && fieldType !== 'group'"
            >
                <nz-form-control>
                    <label
                        style="margin-top: 10px"
                        nz-checkbox
                        formControlName="isHidden"
                        >Is Hidden</label
                    >
                    <i
                        nz-icon
                        nzType="info-circle"
                        nzTheme="outline"
                        nz-tooltip
                        nzTooltipTitle="hide the field from UI, it will not show in form and will
                    be filled pragmatically instead by user input"
                    ></i>
                </nz-form-control>
            </nz-form-item>
            <!-- default value -->
            <nz-form-item
                *ngIf="fieldType !== 'section' && fieldType !== 'group'"
            >
                <nz-form-label>Default value </nz-form-label>
                <nz-form-control nzErrorTip="Required">
                    <input
                        nz-input
                        placeholder="Default Value"
                        formControlName="defaultValue"
                        (blur)="setDefaultValue()"
                    />
                </nz-form-control>
            </nz-form-item>

            <!-- Conditions -->
            <ng-container
                formArrayName="conditions"
                *ngIf="fieldType !== 'group'"
            >
                <nz-form-label>Conditions </nz-form-label>
                <ng-container
                    *ngIf="
                        activeField.field
                            | otherFields : fields as conditionFields
                    "
                >
                    <ng-container
                        *ngIf="
                            conditionFields.length;
                            else noAvailableConditionFieldsTpl
                        "
                    >
                        <ng-container
                            *ngFor="
                                let conditionFG of conditionsFA.controls;
                                let i = index
                            "
                        >
                            <nz-form-item
                                class="from-array-item"
                                [formGroup]="$any(conditionFG)"
                                [class.invalid-FA]="
                                    !conditionsFA.valid && conditionsFA.dirty
                                "
                            >
                                <nz-form-control nzErrorTip="Required">
                                    <nz-select
                                        formControlName="name"
                                        style="width: 100%"
                                    >
                                        <nz-option
                                            *ngFor="
                                                let field of conditionFields
                                            "
                                            [nzValue]="field.name"
                                            [nzLabel]="field.label"
                                        >
                                        </nz-option>
                                    </nz-select>
                                </nz-form-control>

                                <nz-form-control nzErrorTip="Required">
                                    <nz-select
                                        formControlName="value"
                                        style="width: 100%"
                                    >
                                        <nz-option
                                            *ngFor="let opt of ['Yes', 'No']"
                                            [nzValue]="opt"
                                            [nzLabel]="opt"
                                        >
                                        </nz-option>
                                    </nz-select>
                                </nz-form-control>

                                <button
                                    nz-button
                                    type="button"
                                    (click)="deleteCondition(i)"
                                >
                                    <i nz-icon nzType="delete"></i>
                                </button>
                            </nz-form-item>
                        </ng-container>

                        <div>
                            <button
                                nz-button
                                type="button"
                                (click)="addCondition()"
                            >
                                <i class="fa-solid fa-plus"></i>
                                Add condition
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #noAvailableConditionFieldsTpl>
                        <nz-alert
                            nzType="warning"
                            nzMessage="At least one polar(yes/no) type field must exist on the form to use conditions"
                        ></nz-alert>
                    </ng-template>
                </ng-container>
            </ng-container>

            <!-- Groups -->
            <ng-container *ngIf="fieldType !== 'group'">
                <nz-form-label style="margin-top: 1rem"
                    >Parent Group:
                </nz-form-label>
                <ng-container
                    *ngIf="activeField.field | groupFields : fields as groups"
                >
                    <ng-container
                        *ngIf="groups.length; else noAvailableGroupsTpl"
                    >
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Required">
                                <nz-select
                                    formControlName="group"
                                    style="width: 100%"
                                    nzAllowClear
                                >
                                    <nz-option
                                        *ngFor="let group of groups"
                                        [nzValue]="group.name"
                                        [nzLabel]="group.name"
                                    >
                                    </nz-option>
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                    </ng-container>
                    <ng-template #noAvailableGroupsTpl>
                        <nz-alert
                            nzType="warning"
                            nzMessage="No available Groups"
                        ></nz-alert>
                    </ng-template>
                </ng-container>
            </ng-container>

            <nz-divider></nz-divider>

            <!-- actions -->
            <div class="form-actions">
                <button
                    *ngIf="
                        activeField.mode === 'edit' &&
                        !activeField.field.mandatory
                    "
                    nz-button
                    type="button"
                    nzType="text"
                    nzDanger
                    type="button"
                    (click)="removeField()"
                >
                    Delete
                </button>
                <div style="flex: 1"></div>
                <button
                    nz-button
                    type="button"
                    [nzType]="'default'"
                    type="button"
                    (click)="closeActiveField()"
                >
                    Cancel
                </button>
                <button
                    nz-button
                    type="button"
                    [nzType]="'primary'"
                    (click)="saveActiveField()"
                >
                    {{ activeField.mode === 'add' ? 'Create' : 'Save' }}
                </button>
            </div>
        </form>
    </ng-container>
</nz-drawer>

<!-- ----------------------------------------------------------------------- -->
<!--                                Tepmlates                                -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #addFieldPopoverTitleTemplate>Chose the field type </ng-template>
<ng-template #addFieldPopoverContentTemplate>
    <div class="add-field-popover-grid">
        <button
            *ngFor="let field of filedTypesArr"
            nz-button
            nzType="text"
            [disabled]="filedTypes[field.type].disabled"
            (mousedown)="addNewField($any(field).type)"
        >
            <i nz-icon [nzType]="field.icon" nzTheme="outline"></i>
            {{ field.label }}
        </button>
    </div>

    <div
        style="text-align: center; padding-bottom: 10px"
        *ngIf="schemas && schemas.length"
    >
        <nz-divider nzPlain nzText="or"></nz-divider>
        <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
            Add a field from schema
            <i nz-icon nzType="down"></i>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
                <li
                    nz-submenu
                    *ngFor="let schema of schemas"
                    [nzTitle]="schema?.title"
                >
                    <ul>
                        <li
                            nz-submenu
                            *ngFor="let group of schema?.content"
                            [nzTitle]="group.title"
                        >
                            <ul>
                                <li
                                    *ngFor="let field of $any(group).fields"
                                    nz-menu-item
                                    (mousedown)="
                                        addSchemaField(field, $any(group), $any(schema))
                                    "
                                >
                                    {{ field.label }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </nz-dropdown-menu>
    </div>
</ng-template>
